import * as UT from "@app/services/UserTiming.service";
import { UserTimingService } from "@app/services/UserTiming.service";
import { moneyAdd, moneyNumber } from "@app/util/money-number";
import { HeaderService } from "@app/components/header/header.service";
import { CheckingAccount } from "@app/models/CheckingAccount";
import { Homeowner } from "@app/models/Homeowner";
import { Payment } from "@app/models/Payment";
import { PaymentMethod } from "@app/models/PaymentMethod";
import { PaymentRequest } from "@app/models/PaymentRequest";
import { Property } from "@app/models/Property";
import { FTNIAchTokenRequest, FTNIAchTokenResponse, FTNIApi } from "../../../services/apiServices/FTNIApi";
import { PaymentApi } from "@app/services/apiServices/PaymentApi";
import { PaymentMethodApi } from "@app/services/apiServices/PaymentMethodApi";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { SpinnerService } from "@app/services/spinner.service";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { PaymentEntityType } from "@app/models/PaymentEntityType";
import { catchError, finalize, map, switchMap, take, takeUntil, tap } from "rxjs/operators";
import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { PaymentErrorDialog } from "@app/components/sharedDialogs/dialogPaymentError.component";
import { AppDate } from "@app/util/app-date";
import { PaymentDateService } from "@app/services/PaymentDate.service";
import { AppDataService } from "@app/services/appData.service";
import { CheckRoutingNumberHelperDialog } from "@app/pages/wallet/checkadd/checkRoutingNumberHelper.dialog";
import { CheckAccountNumberHelperDialog } from "@app/pages/wallet/checkadd/checkAccountNumberHelper.dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentTimingType } from "@app/services/shared/PaymentTimingType.enum";
import { ScheduleFrequencyType } from "@app/services/shared/ScheduleFrequencyType.enum";
import { PaymentCorrelationRequest } from "@app/models/PaymentCorrelation";
import { EMPTY, Subject } from "rxjs";
import { PaymentCorrelationService } from "@app/services/payment-correlation.service";
import { ErrorHandlerService } from "@app/services/ErrorHandler.service";

const CHECKING_ACCOUNT_ZERO_VALUE: CheckingAccount = {
    routingNumber: "",
    accountNumber: "",
    accountNumberConfirm: "",
    nickname: "",
    defaultPaymentMethod: false,
    accountHolderName: "",
    bankName: "",
    payerId: null,
    savingsAccountIndicator: "checking"
};

@Component({
    selector: 'app-guest-payment-check',
    template: require('./guestPaymentCheck.html')
})

export class GuestPaymentCheckComponent implements OnInit, OnDestroy {
    @ViewChild('GuestPaymentCheck', { static: true }) private guestPaymentCheckForm;

    paymentDate: AppDate;
    paymentDateDisplay: string;

    checkingAccount: CheckingAccount;
    paymentRequest: PaymentRequest;

    tokenResponse: FTNIAchTokenResponse;

    achTokenRequest: FTNIAchTokenRequest;

    homeowner: Homeowner;
    property: Property;
    // from state params

    totalPaymentAmount: number;

    ACHMessage: string;
    isValidRoutingNumber: boolean;
    routingErrorMsg: string;
    validAccount: boolean;
    accountNumberErrorMsg: string;
    accountNumberConfirmErrorMsg: string;
    paymentAmtErrMsg: string;
    tcCheckbox: boolean;
    paymentDateErrorMsg: string;
    staticMode: boolean;
    hideResetAmountLink: boolean = true;
    maskedAccountNumber: string;
    paymentEntityType: PaymentEntityType;

    /** do not set directly! */
    convenienceFee: number | string;

    maxPrincipalAmount: number;

    /** do not set directly! */
    paymentAmount: number | string;
    private destroy$ = new Subject<void>();

    constructor(
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(HeaderService) private HeaderService: HeaderService,
        // close header on construction
        @Inject(PaymentMethodApi) private PaymentMethodApi: PaymentMethodApi,
        // for getting bank name of routing number
        @Inject(MatDialog) private dialog: MatDialog,
        // open terms and helper info
        @Inject(PaymentApi) private paymentApi: PaymentApi,
        // get convenience fee
        @Inject(FTNIApi) private FTNIApi: FTNIApi,
        // for getting payment token from values
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(PaymentDateService) private pmtDateService: PaymentDateService,
        @Inject(PaymentCorrelationService) private paymentCorrelationService: PaymentCorrelationService,
        @Inject(UserTimingService) private userTiming: UserTimingService,
        @Inject(Router) private router: Router,
        @Inject(ErrorHandlerService) private errorHandlerService: ErrorHandlerService,
        @Inject(ActivatedRoute) private activatedRoute: ActivatedRoute) {

        this.paymentEntityType = this.activatedRoute.snapshot.data.paymentEntityType;
    }

    ngOnInit() {
        this.spinnerService.closeSpinner();
        this.HeaderService.setDisplayRightContent(false);

        // init empty checking account info
        this.checkingAccount = CHECKING_ACCOUNT_ZERO_VALUE;

        this.setDefaultValues()

        try {
            this.pmtDateService.delayTodaysPayment = this.guestPaymentStore.getDelayTodaysPayment();
        } catch (_invalidDateOrPropertyAccessError) { }
        //Get the valid payment date
        this.loadValidPaymentDate();

        // this.paymentDate = this.pmtDateService.getNextValidDate(pmtDate, this.appDataService.appConfig.CUTOFF_HOUR, this.appDataService.appConfig.CUTOFF_MINUTE, pmtDate.addDays(365));
        this.maxPrincipalAmount = this.appDataService.appSettings.paymentLimits.maxPrincipalAmount;
    }

    private loadValidPaymentDate() {
        this.paymentApi.getPaymentDate(this.pmtDateService.delayTodaysPayment, true).pipe(
            take(1),
            takeUntil(this.destroy$),
            finalize(() => this.spinnerService.closeSpinner())
        ).subscribe({
            next: (response) => {
                this.paymentDate = AppDate.fromString(response.paymentDate, 'yyyy-MM-dd');
                this.paymentDateDisplay = this.paymentDate.format('MM/dd/yyyy');
            },
            error: (err) => {
                console.error("Error loading valid payment date:", err);
                const errMsg = err?.error?.message || undefined;
                this.errorHandlerService.handleNetworkError(err, true, errMsg);
            }
        })
    }

    private setConvenienceFee(value: number) {
        value = Number(value)
        if (isNaN(value) || value < 0) this.convenienceFee = ''
        else this.convenienceFee = value.toFixed(2)
        this.updateTotalAmount()
    }

    private setPaymentAmount(value: number, validate: 'validate' | 'no validate' = 'validate') {
        value = Number(value)

        if (isNaN(value) || value <= 0) this.paymentAmount = ''
        else this.paymentAmount = value.toFixed(2)

        this.paymentAmtErrMsg = null
        if (validate === 'validate') {
            this.validatePaymentAmount()
        }

        // Update dependent parts
        this.updateResetOriginalAmountLink()
        this.updateConvenienceFee()
        this.updateTotalAmount()
    }

    private validatePaymentAmount() {
        const paymentAmountNum: number = Number(this.paymentAmount);
        this.updateResetOriginalAmountLink();

        if (this.paymentAmount == null || this.paymentAmount === '' || paymentAmountNum === 0) {
            this.paymentAmtErrMsg = "Payment amount is required.";

        } else if (isNaN(paymentAmountNum)) {
            this.paymentAmtErrMsg = "Payment amount must be a number.";

        } else if (this.maxPrincipalAmount && paymentAmountNum > this.maxPrincipalAmount) {
            this.paymentAmtErrMsg = "Payment amount cannot exceed $" + this.maxPrincipalAmount;

        } else {
            this.paymentAmtErrMsg = null;
        }
    }

    initializeStaticMode() {
        this.staticMode = true;

        this.checkRoutingNumber();

        // if we already have the paymentToken, allow the user through
        if (this.paymentRequest && this.paymentRequest.paymentMethod && this.paymentRequest.paymentMethod.token) {
            this.validAccount = true;
            this.accountNumberConfirmErrorMsg = null;
            this.accountNumberErrorMsg = null;
        } else {
            this.validateAccountNumber();
        }
    }

    /** used to determine if latest change is relevant */
    routingNumberVersion: number = 0

    isCheckingRoutingNumber = false
    checkingRoutingNumberTimeout: any

    checkRoutingNumber(delay = 400) {
        this.routingNumberVersion += 1
        const version = this.routingNumberVersion
        this.isCheckingRoutingNumber = true

        clearTimeout(this.checkingRoutingNumberTimeout);

        if (this.checkingAccount.routingNumber && this.checkingAccount.routingNumber.length === 9) {
            this.checkingRoutingNumberTimeout = setTimeout(() => {
                //call api that takes routing number and returns bank name
                this.PaymentMethodApi.paymentMethodsRoutingNumberGet(this.checkingAccount.routingNumber, true)
                    .pipe(take(1)).subscribe((resp) => {
                        if (this.routingNumberVersion !== version) return
                        this.isCheckingRoutingNumber = false

                        this.isValidRoutingNumber = resp.isValidRoutingNumber;

                        if (this.isValidRoutingNumber) {
                            this.checkingAccount.bankName = resp.bankName;
                            this.routingErrorMsg = null;
                        } else {
                            this.checkingAccount.bankName = null;
                            this.routingErrorMsg = "Please enter a valid routing number.";
                        }
                    }, (err) => {
                        this.checkingAccount.bankName = null;
                        this.isValidRoutingNumber = false;
                        this.routingErrorMsg = "Please enter a valid routing number.";
                        this.networkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.checkRoutingNumber(0);
                            }
                        });
                    });
            }, delay);

        } else {
            this.checkingAccount.bankName = null;
            this.isValidRoutingNumber = false;
            this.routingErrorMsg = "Please enter a valid routing number.";
            this.isCheckingRoutingNumber = false;
        }
    }

    valid(): boolean {
        return (
            this.isValidRoutingNumber
            && !this.convenienceFeeIsPending
            && this.validAccount
            && Number(this.paymentAmount)
            && this.paymentDate
            && this.tcCheckbox
            && !this.paymentAmtErrMsg
            && !this.paymentDateErrorMsg
            && !this.isCheckingRoutingNumber
            && !this.isCheckingAccountNumber
        )
    }

    invalid(): boolean {
        return !this.valid()
    }

    checkingAccountNumberTimeout: any
    isCheckingAccountNumber = false
    validateAccountNumber(delay = 400) {
        this.isCheckingAccountNumber = true
        clearTimeout(this.checkingAccountNumberTimeout)

        this.checkingAccountNumberTimeout = setTimeout(() => {
            // Check formctrl
            if (this.guestPaymentCheckForm != null) {
                if (this.guestPaymentCheckForm.accountNumber && !this.guestPaymentCheckForm.accountNumber.$invalid) {
                    this.accountNumberErrorMsg = null;
                    this.validAccount = false;
                }

                if (this.guestPaymentCheckForm.accountNumberContrm && !this.guestPaymentCheckForm.accountNumberConfirm.$invalid) {
                    this.accountNumberConfirmErrorMsg = null;
                    this.validAccount = false;
                }

                const invalidAcctNumber = this.guestPaymentCheckForm.accountNumber && this.guestPaymentCheckForm.accountNumber.$invalid
                const invalidAcctNumberConfirmation = this.guestPaymentCheckForm.accountNumberConfirm && this.guestPaymentCheckForm.accountNumberConfirm.$invalid
                const GENERIC_ACCT_NUM_ERR = "Please enter a valid account number."
                if (invalidAcctNumber || invalidAcctNumberConfirmation) {
                    // Note to refactor this duplicated logic
                    if (isInvalidAcctNum(this.checkingAccount.accountNumber)) {
                        this.accountNumberErrorMsg = GENERIC_ACCT_NUM_ERR
                    }
                    if (isInvalidAcctNum(this.checkingAccount.accountNumberConfirm)) {
                        this.accountNumberConfirmErrorMsg = GENERIC_ACCT_NUM_ERR
                    }
                    return;
                }
            }

            if (this.checkingAccount.accountNumber && this.checkingAccount.accountNumberConfirm) {
                if (this.checkingAccount.accountNumber === this.checkingAccount.accountNumberConfirm) {
                    this.validAccount = true;
                    this.accountNumberErrorMsg = null;
                    this.accountNumberConfirmErrorMsg = null;
                } else {
                    this.validAccount = false;
                    this.accountNumberErrorMsg = "Account numbers do not match.";
                    this.accountNumberConfirmErrorMsg = "Account numbers do not match.";
                }
            } else {
                this.validAccount = false;
                this.accountNumberErrorMsg = "Please enter a valid account number.";
                this.accountNumberConfirmErrorMsg = "Please enter a valid account number.";
            }

            this.isCheckingAccountNumber = false
        }, delay);
    }

    getOriginalAmount(): number {
        // Baldwin: Treat redirect amount as an amount which is just filled in really fast (MMDP-2248)
        //          If there is no amount due from the billing summary, then there should not be any
        //          "Reset Original Amount" link
        return this.guestPaymentStore.getPropertyAmountDue()
            || undefined
    }

    updateResetOriginalAmountLink() {
        const paymentAmountNum = Number(this.paymentAmount)

        // check to see if the link needs to be shown
        const originalAmount = this.getOriginalAmount();
        if (originalAmount == null) {
            // if there is no original amount, hide the link
            this.hideResetAmountLink = true;
            return
        }

        this.hideResetAmountLink = !(paymentAmountNum !== originalAmount);
    }

    updateTotalAmount() {
        this.totalPaymentAmount = moneyAdd(Number(this.convenienceFee) || 0, this.paymentAmount);
    }

    /** invalid if pending */
    convenienceFeeIsPending = false
    updateConvenienceFeeTimer: any
    updateConvenienceFee(delay: number = 800) {
        // use cancel to debounce
        clearTimeout(this.updateConvenienceFeeTimer)
        this.convenienceFeeIsPending = true

        // manually invoke a delay here so the convenience fee formula is not so obvious
        this.updateConvenienceFeeTimer = setTimeout(() => {
            // falsey if paymentAmount is 0 or NaN
            if (this.property && Number(this.paymentAmount)) {
                this.paymentApi.convenienceFeePropertyIdAmountGet(
                    true,
                    this.property.address.state,
                    this.property.address.state,
                    moneyNumber(this.paymentAmount),
                    this.property.hoa.pmc.couponId,
                    this.property.hoa.couponId,
                    "ACH",
                    PaymentTimingType.ONE_TIME,
                    ScheduleFrequencyType.ONE_TIME
                ).pipe(take(1))
                    .subscribe({
                        next: data => {
                            this.setConvenienceFee(data.convenienceFee);
                            this.updateTotalAmount();
                            this.convenienceFeeIsPending = false

                        },
                        error: err => {
                            this.networkErrorService.handleNetworkError(err, false)
                                .pipe(take(1)).subscribe((resp) => {
                                    if (resp === true) {
                                        this.updateConvenienceFee();
                                    }
                                });
                        }
                    })
            }
        }, delay);
    }

    onPmtAmtInputChange = () => {
        this.updateConvenienceFee(1000)
        this.validatePaymentAmount()
    }

    onPmtAmtInputFocus() {
        this.clearPaymentAmtIf0()
    }

    onPmtAmtInputBlur() {
        this.setPaymentAmount(Number(this.paymentAmount))
        this.clearPaymentAmtIf0()
    }

    clearPaymentAmtIf0() {
        if (!Number(this.paymentAmount)) {
            this.setPaymentAmount(null, 'validate');
            this.setConvenienceFee(0);
        }
    }

    clearPaymentAmount() {
        this.setPaymentAmount(null, 'validate');
        this.setConvenienceFee(0);
    }

    resetPaymentAmount() {
        this.setPaymentAmount(this.getOriginalAmount(), 'no validate')
    }

    setDefaultValues() {
        this.homeowner = this.guestPaymentStore.getHomeowner();
        this.property = this.guestPaymentStore.getProperty();
        this.paymentRequest = this.guestPaymentStore.getPaymentRequest();
        if (!this.paymentRequest)
            this.paymentRequest = {} as PaymentRequest
        if (this.homeowner == null || this.property == null) {
            !window.__karma__ && console.error('Either homeowner or property was undefined. Redirecting to guest contact form.', { homeowner: this.homeowner, property: this.property })
            // redirect to page for filling out info
            this.router.navigateByUrl('/guestpayment');
            return
        }
        this.updateHomeownerInfo();

        this.ACHMessage = "Please note: you are making a payment through First Citizens Bank’s proprietary ACH payment system.";

        // pre-fill the guest payment ACH fields in edit mode (only available in current session)
        let canInitializeStatic = false;
        this.achTokenRequest = this.guestPaymentStore.getAchTokenRequest();

        if (this.achTokenRequest != null) {
            if (this.achTokenRequest.hasOwnProperty('routingNumber')) {
                this.checkingAccount.routingNumber = this.achTokenRequest.routingNumber;
                setTimeout(() => {
                    this.validateAccountNumber()
                });
            }

            if (this.achTokenRequest.hasOwnProperty('accountNumber')) {
                this.checkingAccount.accountNumber = this.achTokenRequest.accountNumber;
                this.checkingAccount.accountNumberConfirm = this.achTokenRequest.accountNumber;
                let acctNumMasked = this.achTokenRequest.accountNumber.length <= 4 ?
                    this.achTokenRequest.accountNumber.slice(-2) :
                    this.achTokenRequest.accountNumber.slice(-4);
                this.maskedAccountNumber = "xxxx" + acctNumMasked;
            }

            if (this.achTokenRequest.hasOwnProperty('customerName')) {
                this.checkingAccount.accountHolderName = this.achTokenRequest.customerName;
            }

            if (this.achTokenRequest.hasOwnProperty('bankName')) {
                this.checkingAccount.bankName = this.achTokenRequest.bankName;
            }
            canInitializeStatic = true;
        } else {
            this.checkingAccount.routingNumber = ""
            this.checkingAccount.accountNumber = ""
            this.checkingAccount.accountNumberConfirm = ""
        }

        // reset the payment amount first, then next check if value already made
        this.resetPaymentAmount()

        const redirectAmount = this.guestPaymentStore.getRedirectAmount()
        if (redirectAmount != null) {
            // MMDP-2248: Redirect amount should behave just as though the user quickly typed in their information
            this.setPaymentAmount(redirectAmount, 'validate')
        }

        // Check if a payment amount has already been entered first to handle when a user goes back to edit payment
        const paymentFromSession = this.guestPaymentStore.getPayment();
        if (paymentFromSession) {
            if (paymentFromSession.hasOwnProperty('principalAmount')) {
                this.setPaymentAmount(paymentFromSession.principalAmount);
            }

            if (paymentFromSession.hasOwnProperty('totalPaymentAmount')) {
                this.totalPaymentAmount = moneyNumber(paymentFromSession.totalPaymentAmount);
            }

            if (paymentFromSession.hasOwnProperty('feeAmount')) {
                this.setConvenienceFee(paymentFromSession.feeAmount);
                this.updateConvenienceFee()
            }
        }

        // update convenience fee on load
        this.updateConvenienceFee();

        if (canInitializeStatic) {
            this.initializeStaticMode();
        }
    }

    getPayment(): Payment {
        return {
            feeAmount: moneyNumber(this.convenienceFee),
            totalPaymentAmount: moneyNumber(this.totalPaymentAmount),
            principalAmount: moneyNumber(this.paymentAmount),
        }
    }

    getPaymentMethod(paymentToken: string, payerId: number): PaymentMethod {
        if (typeof paymentToken !== 'string' || !paymentToken) throw new TypeError('Expected paymentToken to be string');
        if (typeof payerId !== 'number' || isNaN(payerId)) throw new TypeError('Expected payerId to be number');

        return {
            token: paymentToken,
            payerId: payerId,
            routingNumber: this.checkingAccount.routingNumber, // necessary to distinguish between card and check
            maskedId: this.checkingAccount.accountNumber.length <= 4 ? this.checkingAccount.accountNumber.slice(-2) : this.checkingAccount.accountNumber.slice(-4)
        }
    }

    /**
     * Set {@link GuestPaymentCheckComponent::paymentRequest} based on form values and parameters
     * @param paymentToken FTNI payment token used to identify payment method registered with FTNI
     * @param payerId The homeownerId paying the due
     */
    createPaymentRequest(paymentToken, payerId) {
        const today = AppDate.now()
        const nextPmtDate = this.pmtDateService.getNextValidDate(today, this.appDataService.appConfig.CUTOFF_HOUR, this.appDataService.appConfig.CUTOFF_MINUTE, today.addDays(365))
        const isFutureDatedPayment = this.paymentDate.isAfter(nextPmtDate)
        const dObjPaymentDate = this.pmtDateService.dateObjectFromAppDate(this.paymentDate)

        this.paymentRequest = {
            payment: this.getPayment(),

            // Current implementation is that effectiveDate = paymentDate
            // since the backend will 400 if effectivedate is in future and futureDatedPayment = false
            paymentDate: dObjPaymentDate,

            // effective date represents the date it will be processed.
            // MMDP-1890
            effectiveDate: dObjPaymentDate,

            // if this payment date is after the date which would typically process
            futureDatedPayment: isFutureDatedPayment,

            paymentMethod: this.getPaymentMethod(String(paymentToken), Number(payerId)),
            paymentSiteId: this.property.hoa.paymentSiteId,
            property: this.property,
            acceptedTerms: this.tcCheckbox,
            acceptedTermsDate: today.format("yyyy-MM-dd"),
            paymentEntityType: this.paymentEntityType === PaymentEntityType.AMENITY ? PaymentEntityType.AMENITY : PaymentEntityType.PROPERTY,
            details: this.paymentRequest ? this.paymentRequest.details : null
        };
        this.achTokenRequest = {
            routingNumber: this.checkingAccount.routingNumber,
            accountNumber: this.checkingAccount.accountNumber,
            customerName: this.checkingAccount.accountHolderName,
            bankName: this.checkingAccount.bankName,
            customerId: null,
            bankAccountType: this.checkingAccount.savingsAccountIndicator
        };
    }

    onSubmit() {
        this.spinnerService.showSpinner();
        // Create User Timer for analytics
        const submitTimer = this.userTiming.startTimer(UT.CATEGORIES.FTNI, 'Create ACH Payment Token', 'Verifying ACH Payment Details');

        this.FTNIApi.privateProcessACHPost(this.checkingAccount).pipe(
            take(1),
            switchMap(resp => {
                this.tokenResponse = resp;

                if (!this.tokenResponse?.BankToken) {
                    submitTimer.stop("ACH Token Creation Payment Error");

                    this.dialog.open(PaymentErrorDialog, {
                        data: { error: "Check Processing Error" },
                    });
                    return EMPTY;
                }

                submitTimer.stop("ACH Token Creation Succeeded");

                this.createPaymentRequest(this.tokenResponse.BankToken, this.homeowner.id);
                this.guestPaymentStore.setAchTokenRequest(this.achTokenRequest);
                this.guestPaymentStore.setPayment(this.getPayment());
                this.guestPaymentStore.setPaymentRequest(this.paymentRequest);

                this.guestPaymentStore.clearCorrelationId();

                const correlationRequest: PaymentCorrelationRequest = {
                    payerId: this.homeowner.id,
                    entityId: this.property.id.toString(),
                };

                return this.paymentCorrelationService
                    .createCorrelationId(true, correlationRequest)
                    .pipe(take(1));
            }),
            catchError(err =>
                this.networkErrorService.handleNetworkError(
                    err.error?.message,
                    true,
                ).pipe(
                    take(1),
                    tap(value => {
                        if (value === "Retry") {
                            this.onSubmit();
                        }
                    }),
                    map(() => null),
                ),
            ),
            finalize(() => this.spinnerService.closeSpinner()),
        ).subscribe(correlationId => {
            if (!correlationId) {
                return;
            }

            this.guestPaymentStore.setCorrelationId(correlationId);

            const nextPage =
                this.paymentEntityType === PaymentEntityType.AMENITY
                    ? '/amenities/guestPaymentConfirmation'
                    :'/guestPaymentConfirmation';

            this.router.navigateByUrl(nextPage, {
                state: {
                    paymentRequest: this.paymentRequest,
                    homeowner: this.homeowner
                }
            });
        });
    }

    onClickBack() {
        this.router.navigateByUrl(this.paymentEntityType === PaymentEntityType.AMENITY ? '/amenities/select' : '/guestpayment');
    }

    routingNumberHelper() {
        this.dialog.open(CheckRoutingNumberHelperDialog);
    }

    accountNumberHelper() {
        this.dialog.open(CheckAccountNumberHelperDialog);
    }

    updateHomeownerInfo() {
        if (this.homeowner.hasOwnProperty('id')) {
            this.checkingAccount.payerId = this.homeowner.id;
        }

        if (this.homeowner.hasOwnProperty('firstName') && this.homeowner.hasOwnProperty('lastName')) {
            this.checkingAccount.accountHolderName = this.homeowner.firstName + " " + this.homeowner.lastName;
        }
    }

    clearStaticMode() {
        this.staticMode = false;
        this.checkingAccount.routingNumber = null;
        this.checkingAccount.accountNumber = null;
        this.checkingAccount.accountNumberConfirm = null;
        this.checkingAccount.bankName = null;
        this.routingErrorMsg = null;
        this.accountNumberErrorMsg = null;
        this.accountNumberConfirmErrorMsg = null;
        this.guestPaymentStore.clearAchTokenRequest()
        this.checkRoutingNumber();
        this.validateAccountNumber();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}

/** Check if an account number is valid */
function isInvalidAcctNum(num: string): boolean {
    return num == null || typeof num === "string" && (num.length < 3 || num.length > 17)
}
